module.exports = __webpack_public_path__ + "static/media/room-10.f3b74e52.jpeg";